import { Controller, useFormContext } from 'react-hook-form';
import { styled } from '@mui/material/styles';
import { Typography } from '@components/Typography';
import SpecialHoursSelection from '@features/SpecialHoursSelection';
import { hasPublishedWorkingHours } from '@helpers/companies';
import { useTranslation } from '@hooks';

const Form = styled('div')({
    maxWidth: 698,
    display: 'grid',
    rowGap: 16,
    gridTemplateColumns: 'minmax(0, 1fr)',
    '@media (max-width: 1024px)': {
        gridTemplateColumns: 'minmax(0, 1fr)',
        maxWidth: 'none',
    },
});

const SpecialHours = () => {
    const { t } = useTranslation();
    const {
        control,
        setValue,
        watch,
        formState: { errors },
    } = useFormContext();
    const hoursPublished = hasPublishedWorkingHours(watch('workingHoursEnabled'), watch('workingHours'));

    return (
        <Form>
            {!hoursPublished && (
                <Typography variant="body2" color="textSecondary">
                    {t('SettingsCompanies.specialHoursNeedBusinessHours')}
                </Typography>
            )}
            <Controller
                control={control}
                name="specialHours"
                render={({ field, ref }) => (
                    <SpecialHoursSelection
                        {...field}
                        data={field?.value || []}
                        ref={ref}
                        canAdd={hoursPublished}
                        onChange={value => {
                            setValue('specialHours', value, { shouldDirty: true, shouldValidate: true });
                        }}
                    />
                )}
            />
            {errors.specialHours?.message && (
                <Typography variant="caption" color="error">
                    {t(errors.specialHours.message)}
                </Typography>
            )}
        </Form>
    );
};

export default SpecialHours;
